export default "__VITE_ASSET__B1cXv$Cj__"